// extracted by mini-css-extract-plugin
export default {"mt":"homepagerecomment_mt__XPyXM"};